import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { LocalStorageService } from './../../shared/services/storage/local-storage.service';
import { WebServiceService } from './../../shared/services/web-service.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';
import { LogoutService } from '../../shared/services/logout.service';
import { CompanyLicenseLoginService } from '../../shared/services/company-license-login.service';
import { AuthSessionService } from '../../shared/services/auth-session.service';
import { DataService } from '../../shared/services/data-sharing/data.service';
import { CostCenterStorageService } from '../../shared/services/storage/cost-center-storage.service';
import {
  applyUiModeToRedirectPath,
  hrefForAppHashPath,
  isOpsCorePathnameShell,
  isOpsCoreSupportedRoute,
  isPublicAuthBypassPath,
  markTabOpenedModernUrl,
  pathHasOpsCorePrefix,
  recordClassicChoiceOnReturnFromModern,
  rememberModernUiByDefault,
  shouldShowUiModeToggle,
  stripOpsCoreFromPath,
  writeUiModePreference,
  writeUiModeUserChoice,
} from '../../shared/utils/ui-mode';
import { TYA_COMPANY_HEADER_REFRESH_EVENT, GroupMailedInvoiceCompanyContextService } from '../../shared/services/group-mailed-invoice-company-context.service';

@Component({

  selector: 'app-dynamic-menu',
  templateUrl: './dynamic-menu.component.html',
  styleUrls: ['./dynamic-menu.component.scss'],
  providers: [WebServiceService, CompanySetupService, EesDesService]
})
export class DynamicMenuComponent implements OnInit, OnDestroy {

  private uiModeNavSubscription: Subscription | undefined;
  private onCompanyHeaderRefresh = () => this.refreshHeaderCompanyDisplay();

  in_progress:boolean=true;
  isOpened: boolean = true;
  isclosed: boolean = false;
  is_active:boolean=false;
  already_active_msg:any=''
  prevClicked: number = -1;
  userName: string = '';
  companyName: string = '';
  menuList: any = [];
  storeMenudata: any = [];
  isTrue: boolean = false;
  empDetails: any = [];
  companies: any = [];
  isMultiple: boolean = false;
  id: any = 0;
  companyLogo: any = "";
  isSearch: boolean = false;
  searchBox: any = "";
  searchListItems: any = [];
  notificationList: any = [];
  searchedItem: any = '';
  searchModel: any = '';
  userCode: any = "";
  userProfileImage: any = '';
  country_data:any={};
  after_logout_redirect_to_specific_url:any = "";
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  CheckthemeImage:any ="";
  isVendorLogin: boolean = false;
  isModernUiEnabled: boolean = false;
  showUiModeToggle: boolean = false;
  isAskQueryPopupOpen: boolean = false;
  isAskQueryModuleOpen: boolean = false;
  isAskQueryDragOver: boolean = false;
  askQueryModules: any[] = [];
  askQueryPriorities: string[] = ['Critical', 'High', 'Medium', 'Low'];
  askQueryAttachments: any[] = [];
  pendingAskQueryPayload: any = null;
  askQueryData: any = {
    companyName: '',
    userName: '',
    email: '',
    mobile: '',
    moduleId: '',
    moduleName: '',
    query: '',
    priority: ''
  };
  defaultSupportPopupMessage: string = 'Important Support Update\n\nDear User,\n\nTo provide you with better and faster support, all service requests, issue reports, and queries will now be handled exclusively through our official support email.\n\n📧 Support Email: care@tyasuite.com\n\nKindly use this email for all future communications. This will help us track your requests efficiently and ensure timely resolution.\n\nThank you for choosing TYASuite!';
  private supportPopupUserState: any = null;
  private supportPopupConfigState: any = null;
  private supportPopupConfigReady: boolean = false;
  private supportPopupConfigRequestStarted: boolean = false;
  private supportPopupEvaluationCompleted: boolean = false;
  constructor(
    public _localStorageService: LocalStorageService,
    private router: Router,
    private toasterService: ToasterService,
    public webService: WebServiceService,public setup:CompanySetupService,public eesdesService:EesDesService,
    private logoutService: LogoutService,private popupService: DataService,
    private costCenterStorageService: CostCenterStorageService,
    private companyLicenseLoginService: CompanyLicenseLoginService,
    private authSessionService: AuthSessionService
  ) {
    setTimeout(() => {
      this.IsRoleChanged();
    }, 1000);
  }

  currentUrl: any = ''
  company_setup: any = {};
  page_url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  social_login:boolean=false
  social_login_companies:number=0
  enableModernUiFromCompany: boolean = false;
  ngOnInit() {
    this.showLogoutIssue(false);
    recordClassicChoiceOnReturnFromModern();
    this.initializeUiModeFromUrlAndStorage();
    this.uiModeNavSubscription = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.syncUiModeToggleFromBrowserUrl());
    let t:any={};
    t =this.eesdesService.get('country_data',localStorage.getItem('country_data')) ?this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    // console.log(t);
    this.checkBrowsers();
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    else
    {
      this.getCountry();
    }
    this.setTheme('');
    let role:any='';
    role=this._localStorageService.getEmpRoleId()?this._localStorageService.getEmpRoleId():'administrator';
    // this.isVendorLogin = this.eesdesService.get('is_vendor_login',localStorage.getItem('is_vendor_login'));
    this.isVendorLogin=this._localStorageService.getUserRole() == 'vendor'?true:false
    // console.log("isVendorLogin : " + this.isVendorLogin);

    let comp_id:any=this._localStorageService.getEmpCompanyId()?this._localStorageService.getEmpCompanyId():'0';
    this.isMultiple=this.eesdesService.get('isMultiple',localStorage.getItem('isMultiple'))=='1'?true:false;
    this.social_login=this.eesdesService.get('social_login',localStorage.getItem('social_login'))=='1'?true:false;
    try{
    this.social_login_companies=parseInt(localStorage.getItem('social_login_companies')?localStorage.getItem('social_login_companies'):'0')
    }catch(e){}
    if (this.isMultiple && comp_id=='0') {
      this.webService.redirectURL('/my-companies');

      this.toasterService.pop("info", "Info", "Select Company First!");
      return;
    }
    if(comp_id=='0' && (role!='editor' && role!='administrator'))
    {
      this.logout();
      this.toasterService.pop('warning','Warning','Sorry Wrong Access');

     // this.webService.redirectURL('/login');
    }
    //  console.clear();
    //   console.log('%cStop! You Are Not Allowed', 'color: white; font-size: 30px; font-weight: bold;background:#035168;');
    this.getCompanies();
    this.getMenuList();
    document.body.scrollTop = 0;
    let w = window.innerWidth;
    let dynamicWidth = w < 768 ? 0: 60;
    document.getElementById("base-div").style.paddingTop = "65px";
    document.getElementById("base-div").style.marginLeft = `${dynamicWidth}px`;
    document.getElementById("mySidenav").style.width = `${dynamicWidth}px`;
    document.getElementById("header").style.display = "block";
    this.id = this._localStorageService.getUserId();
    // this.companyLogo = this._localStorageService.getCompanyLogo() ? this._localStorageService.getCompanyLogo() : "./assets/images/tya-logo.png";
    this.companyLogo = this._localStorageService.getCompanyLogo() ? this._localStorageService.getCompanyLogo() : "";
    // console.log(this.companyLogo)
    this.userName = this._localStorageService.getUserName()
    this.userCode =(this.eesdesService.get('employee_code',localStorage.getItem("employee_code"))!=undefined&&this.eesdesService.get('employee_code',localStorage.getItem("employee_code"))!=null&&this.eesdesService.get('employee_code',localStorage.getItem("employee_code"))!='')?"(" + this.eesdesService.get('employee_code',localStorage.getItem("employee_code")) + ")":'';
    this.userCode=this.userCode=='(undefined)'?'':this.userCode;
    this.userProfileImage = this.eesdesService.get('profile_image',localStorage.getItem("profile_image")) ? this.eesdesService.get('profile_image',localStorage.getItem("profile_image")) : '';
    this.userProfileImage = this.userProfileImage ? this.userProfileImage : './assests/images/profile_icon.png'
    this.companyName = this._localStorageService.getCompanyTitle() == undefined || this._localStorageService.getCompanyTitle() == '' ? 'TYA Admin' : this._localStorageService.getCompanyTitle();
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
   if(this.companyThemeBlockColor=="#035168" && this.CompanyThemetextColor=="#FFFFFF")
   {
    this.CheckthemeImage = "#035168";
   }
   else
   {
    this.CheckthemeImage = this.CompanyThemetextColor == '#ffffff' ? this.companyThemeBlockColor : this.CompanyThemetextColor;
  }

    if (this._localStorageService.getUserRole() == 'vendor') {
      // this.getMenuList();
      //  this.getVendorDetails(this._localStorageService.getUserDetails().id)
    }
    else if (this._localStorageService.getUserRole() != 'vendor') {
      // this.getMenuList();
      if (this.page_url == '/dashboard') {
        this.getSupportPopupConfig();
      }
      this.getUserDetails(this.id);
    }
    this.company_setup=this.setup.getData();
    if(!this.company_setup.is_setup)
    {
      if(this.page_url=='/dashboard')
      {
    this.GetCompanySetUpData();
      }
    }
    this.forAdminTheme()
// console.clear();
    if (typeof window !== 'undefined') {
      window.addEventListener(TYA_COMPANY_HEADER_REFRESH_EVENT, this.onCompanyHeaderRefresh);
    }
    this.loadEnableModernUiSetting();
  }

  private refreshHeaderCompanyDisplay(): void {
    this.companyName = this._localStorageService.getCompanyTitle() == undefined || this._localStorageService.getCompanyTitle() == ''
      ? 'TYA Admin'
      : this._localStorageService.getCompanyTitle();
    this.companyData.company_id = this._localStorageService.getEmpCompanyId()
      ? this._localStorageService.getEmpCompanyId().toString()
      : '';
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : '#035168';
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : '#FFFFFF';
  }

  ngOnDestroy(): void {
    if (typeof window !== 'undefined') {
      window.removeEventListener(TYA_COMPANY_HEADER_REFRESH_EVENT, this.onCompanyHeaderRefresh);
    }
    if (this.uiModeNavSubscription) {
      this.uiModeNavSubscription.unsubscribe();
    }
  }

  private getCurrentHashPath(): string {
    const hash = window.location.hash || '';
    const cleaned = hash.replace(/^#/, '').split('?')[0].trim();
    return cleaned ? (cleaned.charAt(0) === '/' ? cleaned : '/' + cleaned) : '/';
  }

  private syncUiModeToggleVisibility(path: string): void {
    this.showUiModeToggle = shouldShowUiModeToggle(path) && this.enableModernUiFromCompany;
  }

  private enforceClassicShellForNonOpsRoute(path: string): void {
    if (typeof window === 'undefined') {
      return;
    }
    if (isPublicAuthBypassPath(path) || pathHasOpsCorePrefix(path)) {
      return;
    }
    if (isOpsCoreSupportedRoute(path)) {
      return;
    }
    if (isOpsCorePathnameShell()) {
      const classicPath = stripOpsCoreFromPath(path);
      const target = hrefForAppHashPath(classicPath, { useRootPathname: true });
      if (window.location.href !== target) {
        window.location.replace(target);
      }
    }
  }

  private initializeUiModeFromUrlAndStorage(): void {
    if (typeof window === 'undefined') {
      this.isModernUiEnabled = false;
      this.showUiModeToggle = false;
      return;
    }
    const path = this.getCurrentHashPath();
    this.syncUiModeToggleVisibility(path);
    if (isPublicAuthBypassPath(path)) {
      const onModern = isOpsCorePathnameShell() || pathHasOpsCorePrefix(path);
      this.isModernUiEnabled = onModern;
      writeUiModePreference(onModern ? 'modern' : 'classic');
      return;
    }
    if (pathHasOpsCorePrefix(path)) {
      writeUiModePreference('modern');
      this.isModernUiEnabled = true;
      return;
    }
    if (isOpsCorePathnameShell() && isOpsCoreSupportedRoute(path)) {
      writeUiModePreference('modern');
      this.isModernUiEnabled = true;
      return;
    }
    // URL is authoritative: legacy-only routes stay classic.
    writeUiModePreference('classic');
    this.isModernUiEnabled = false;
    this.enforceClassicShellForNonOpsRoute(path);
  }

  /** Keeps toggle + storage aligned with hash on in-app navigation (same origin: localhost, QA, prod). */
  private syncUiModeToggleFromBrowserUrl(): void {
    if (typeof window === 'undefined') {
      return;
    }
    const path = this.getCurrentHashPath();
    this.syncUiModeToggleVisibility(path);
    if (isPublicAuthBypassPath(path)) {
      const onModern = isOpsCorePathnameShell() || pathHasOpsCorePrefix(path);
      this.isModernUiEnabled = onModern;
      writeUiModePreference(onModern ? 'modern' : 'classic');
      return;
    }
    if (pathHasOpsCorePrefix(path)) {
      this.isModernUiEnabled = true;
      writeUiModePreference('modern');
      return;
    }
    const onModern = isOpsCorePathnameShell() && isOpsCoreSupportedRoute(path);
    this.isModernUiEnabled = onModern;
    writeUiModePreference(onModern ? 'modern' : 'classic');
    if (!onModern) {
      this.enforceClassicShellForNonOpsRoute(path);
    }
  }

  private buildModeHashPath(enableModern: boolean): string {
    const currentPath = this.getCurrentHashPath();
    const withoutPrefix = stripOpsCoreFromPath(currentPath);
    if (enableModern) {
      return withoutPrefix === '/' || withoutPrefix === '/dashboard'
        ? '/ops-core/dashboard'
        : '/ops-core' + withoutPrefix;
    }
    return withoutPrefix;
  }

  switchUiMode(enableModern: boolean): void {
    if (typeof window === 'undefined') {
      return;
    }
    if (enableModern === this.isModernUiEnabled) {
      return;
    }
    writeUiModeUserChoice(enableModern ? 'modern' : 'classic');
    const hashPath = this.buildModeHashPath(enableModern);
    this.isModernUiEnabled = enableModern;
    if (enableModern) {
      const logical = stripOpsCoreFromPath(hashPath);
      const normalized =
        logical === '/' || logical === '/dashboard' ? '/dashboard' : logical;
      // ops-core only implements a subset of tya-operation; unknown routes would show empty / wildcard.
      const targetLogical = isOpsCoreSupportedRoute(normalized) ? normalized : '/dashboard';
      const hashSeg = targetLogical.replace(/^\//, '').replace(/^\/+/, '') || 'dashboard';
      markTabOpenedModernUrl();
      window.location.href = window.location.origin + '/ops-core/#/' + hashSeg;
      return;
    }
    window.location.href = hrefForAppHashPath(hashPath, { useRootPathname: true });
  }

  GetCompanySetUpData() {
    if (this.company_setup.custom_name_bug_master != undefined && this.company_setup.custom_name_bug_master != '') {
      return;
    }
    let req = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      component:this.constructor.name?this.constructor.name:'',
      variable_list:["fileExtensionList","hide_progress_bar_in_header","custom_name_bug_master","currency_icon","is_update_action_mand_for_incom_ven_profile","landing_url","enable_modern_ui_by_default"],
      "has_comp_access": '1',
    }
    this.company_setup = {}
    this.company_setup.custom_name_bug_master = '';

    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany_limited_as_requested", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup = {}
          // this.setup.setData(data.response);
          this.company_setup = data.response ? data.response : {}
          this.company_setup.is_update_action_mand_for_incom_ven_profile= this.company_setup.is_update_action_mand_for_incom_ven_profile? this.company_setup.is_update_action_mand_for_incom_ven_profile:'0'
          this.company_setup.currency_icon = this.company_setup.currency_icon ? this.company_setup.currency_icon : '';
          this.company_setup.custom_name_bug_master = this.company_setup.custom_name_bug_master ? this.company_setup.custom_name_bug_master : "Bug Master";
          this.company_setup.hide_progress_bar_in_header = this.company_setup.hide_progress_bar_in_header ? this.company_setup.hide_progress_bar_in_header : '0';
          this.company_setup.fileExtensionList=this.company_setup.fileExtensionList?this.company_setup.fileExtensionList:[]
          this.company_setup.landing_url=this.company_setup.landing_url?this.company_setup.landing_url:'1';
          rememberModernUiByDefault(this.company_setup);
          data.has_comp_access = data.has_comp_access ? data.has_comp_access : '0';
          this.company_setup.landing_url = data.has_comp_access=='1' ? this.company_setup.landing_url : '1';

          let navigateToComplianceDashboard = data.has_comp_access=='1' ? true : false;
          // console.log("Company Setup !!"); 
          // let navigateToComplianceDashboard = false;

          // let tmpMenu = this.webService.getMenuByUrl('/my-dashboard');

          // if(tmpMenu)
          // {
          //   console.log(tmpMenu);
          //   return;
          // }

          // if(tmpMenu && tmpMenu.submenu && tmpMenu.submenu.length > 0)
          // {
          //   let tmpObj = tmpMenu.submenu.find(o => o.aurl == '/my-dashboard');
          //   if(tmpObj)
          //   {
          //     navigateToComplianceDashboard = true;              
          //   }
          // }
          let getDataContent = localStorage.getItem('bulkdata_redirectAUrl') ? this.eesdesService.get('bulkdata_redirectAUrl', localStorage.getItem('bulkdata_redirectAUrl')).toString() : '';
          if(getDataContent == undefined || getDataContent=="" || getDataContent==null) {
                          
          } else {
            window.location.href=window.location.origin+'/report/#/download-bulk-data';
          }
          if(this.company_setup.landing_url =='2' && navigateToComplianceDashboard){
            window.location.href=window.location.origin+'/compliance/#/my-dashboard';
            // this.webService.redirectURL('/dashboard');
          }
          
         else{
            if (this.page_url !== '/dashboard') {
              this.webService.redirectURL('/dashboard');
            }
           }

        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
        this.company_setup.custom_name_bug_master = this.company_setup.custom_name_bug_master ? this.company_setup.custom_name_bug_master : "Bug Master";
        if (this._localStorageService.getUserRole() == 'vendor') {
          // this.getMenuList();
           this.getVendorDetails(this._localStorageService.getUserDetails().id)
        }

      }, error => {
        this.toasterService.pop("error", "Error", "Something Went Wrong");
      }
    )
  }
  checkConnection() {
    if (!this.webService.isOnline()) {
      this.toasterService.pop("error", "Error", "Internet is not working");
      return false;
    }
    else {
    }
  }
  makeData() {
    this.menuList = [];
    let data: any = [];
    data = this.eesdesService.get('menus',localStorage.getItem("menus")) ? this.eesdesService.get('menus',localStorage.getItem("menus")) : [];
    this.menuList = data ? data : [];
    this.storeMenudata = this.menuList;
    this.prepareSearchList(this.menuList);
    let currentUrl: string = stripOpsCoreFromPath(window.location.hash.substring(1));
    for (let x of this.menuList) {
      if (x.submenu) {
        for (let d of x.submenu) {
          if (currentUrl == d.aurl) {
            d.activemenu = true;
            x.show = true;
            x.activemenu = true;
            break;
          } else {
            d.activemenu = false
            x.show = false;
            x.activemenu = false;
          }
        }
      }
    }
  }
  is_completed:any='';
  getMenuList() {
    //  this.company_setup=JSON.parse(this.eesdesService.get(localStorage.getItem('company_setup'))?JSON.parse(this.eesdesService.get(localStorage.getItem('company_setup')):{};
    this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';

    let id: any = "";
    if (this._localStorageService.getUserRole() == "administrator") {
      id = "0"
    }
    else {
      id = this._localStorageService.getEmpRoleId() == undefined || this._localStorageService.getEmpRoleId() == null ? "0" : this._localStorageService.getEmpRoleId();

    }
    let data = {
      "id": id,
      "company_id": this._localStorageService.getEmpCompanyId() == undefined || this._localStorageService.getEmpCompanyId() == null ? "0" : this._localStorageService.getEmpCompanyId(),
    }
    if (this.eesdesService.get('is_menu',localStorage.getItem('is_menu')) == undefined || this.eesdesService.get('is_menu',localStorage.getItem('is_menu')) == '' || this.eesdesService.get('is_menu',localStorage.getItem('is_menu')) == null) {
    }
    else {
      this.makeData();
      return;
    }
    this.webService.commonPostMethod("User_Roles/ajax_menu_items_by_user_role", data).
      subscribe(
        data => {
          if (data.status) {
            let temp: any = [];
            if (this.company_setup.merge_grn_irn == '1') {
              //  temp=data.response.filter((v)=>{return v.id!='167'});
              temp = data.response;

            }
            else {
              temp = data.response;

            }
            if(this.eesdesService.get('is_vendor_login',localStorage.getItem('is_vendor_login'))=='1')
            {
              if(this.eesdesService.get('is_completed',localStorage.getItem('is_completed'))=='0')
              {
              temp=temp.filter((v)=>{return v.aurl=='/vendorprofile'})

              }
              if(this.eesdesService.get('is_completed',localStorage.getItem('is_completed'))=='1')
              {
                temp=temp.filter((v)=>{return v.aurl!=='/vendorprofile'})

              }
              // this.is_completed=this.eesdesService.get(localStorage.getItem('is_completed')?this.eesdesService.get(localStorage.getItem('is_completed'):'';
            }
            if (temp) {
              for (let i of temp) {
                if (i.submenu) {
                  for (let j of i.submenu) {
                    if (j.aurl == "/bug-master") {
                      j.menuitemname = this.company_setup.custom_name_bug_master ? this.company_setup.custom_name_bug_master : "Bug Master";
                    }
                    if (j.aurl == "/my-bug-master") {
                      j.menuitemname = "My " + this.company_setup.custom_name_bug_master;
                    }
                  }
                }
              }
            }
            this.menuList = temp;
            this.storeMenudata = temp;

            localStorage.setItem("menus", this.eesdesService.set(JSON.stringify(this.menuList)));
            // localStorage.setItem("menu_lists", JSON.stringify(this.menuList));
            localStorage.setItem("is_menu", this.eesdesService.set('1'));
            // send to last logout
            // this.goToLastUrl(data.project,data.last_logout_url);
            this.prepareSearchList(this.menuList);
            let currentUrl: string = stripOpsCoreFromPath(window.location.hash.substring(1));
            for (let x of this.menuList) {
              if (x.submenu) {
                for (let d of x.submenu) {
                  if (currentUrl == d.aurl && d.aurl!='/dashboard') {

                    d.activemenu = true;
                    x.show = true;
                    x.activemenu = true;
                    break;
                  } else {
                    d.activemenu = false
                    x.show = false;
                    x.activemenu = false;
                  }
                }
              }
            }
            let tmpArr = this.arrayForSearch;
            let matchedArray = []
            if(tmpArr){
              tmpArr.push({id: "00", menuName: "Dashboard", url: "/dashboard", project: "operation"})
              for(let m of tmpArr){
                if(m){
                    if(m.url == this.page_url){
                      matchedArray.push(m)
                    }
                }
              }
            }
            if(!matchedArray.length){
              this.toasterService.pop('warning','Warning','You are not allowed to access this page');
              this.router.navigate(["/login"]);
            }
          }
          setTimeout(() => {
            let elem: any = (<HTMLElement>document.querySelector('.sublist-ul.active'));
            if (elem) {
              elem.style.display = 'none'
            }
          }, 1);
        },
        error => {

        }
      );
  }
  showMenuList(index) {
    this.menuList[index].show = !this.menuList[index].show;
  }
  arrayForSearch: any = [];
  prepareSearchList(data) {
    this.arrayForSearch = [];
    let mainMenuList: any = [];
    let subMenuList: any = []
    for (let x of data) {
      if (x.aurl != '#') {
        mainMenuList.push({
          "id": x.id,
          "menuName": x.menuitemname,
          "url": x.aurl,
          "project": x.project,
        })
      }

      if (x.submenu)
        for (let d of x.submenu) {
          subMenuList.push({
            "id": d.id,
            "menuName": d.menuitemname,
            "url": d.aurl,
            "project": d.project,
          })
        }
      this.arrayForSearch = subMenuList.concat(mainMenuList);
    }
  }
  getCountry() {

    let requestObj = {

    }
    let t:any={}
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    if(t.country_id!==''&&t.country_id!=undefined&&t.country_id!=null)
    {
      this.country_data=t;

    }
    else
    {
    this.webService.commonPostMethod('companies/ajax_all_companies', requestObj).
      subscribe(
        data => {
          if(data.status)
          {
            let list:any=[];
            list=data.response?data.response:[];
            localStorage.setItem('countriesList', JSON.stringify(list));
            let comp_id:any=this._localStorageService.getEmpCompanyId();
            let temp:any=[];
            temp=list.filter((v)=>{return v.id==comp_id});
            if(temp.length>0)
            {
              let country_data:any={'city':temp[0].city?temp[0].city:'',
              'city_name':temp[0].city_name?temp[0].city_name:'',
              'state':temp[0].state?temp[0].state:'',
              'state_name':temp[0].state_name?temp[0].state_name:'',
              'country':temp[0].country?temp[0].country:'101',
              'country_id':temp[0].country?temp[0].country:'101',
              'country_name':temp[0].country_name?temp[0].country_name:'India',
              'country_sortname':temp[0].country_sortname?temp[0].country_sortname:'IN',}
              this.country_data=country_data;
              localStorage.setItem('country_data',this.eesdesService.set(JSON.stringify(country_data)));
              this.after_logout_redirect_to_specific_url = temp[0].after_logout_redirect_to_specific_url ? temp[0].after_logout_redirect_to_specific_url : "";
              this.after_logout_redirect_to_specific_url = this.after_logout_redirect_to_specific_url ? this.after_logout_redirect_to_specific_url : "";
              localStorage.setItem('after_logout_redirect_to_specific_url',this.eesdesService.set(this.after_logout_redirect_to_specific_url));
            }
          }

        }, error => {
        }
      );
      }
  }
  costcenters: any = [];
  companiesArrray: any = [];

  private mapCostCenterRecord(v: any): any {
    return {
      cost_center_id: v.cost_center_id != null ? v.cost_center_id : '',
      '9digit_code': v['9digit_code'] != null ? v['9digit_code'] : '',
      cost_center_name: v.cost_center_name != null ? v.cost_center_name : '',
      costcenter_id: v.costcenter_id != null ? v.costcenter_id : '',
      gst_code: v.gst_code != null ? v.gst_code : '',
      gst_no: v.gst_no != null ? v.gst_no : '',
      isUgstApplicable: v.isUgstApplicable != null ? v.isUgstApplicable : '',
      is_administrative_location: v.is_administrative_location ? v.is_administrative_location : '0',
      location_code_9_digit: v.location_code_9_digit != null ? v.location_code_9_digit : '',
      location_nickname_9_digit: v.location_nickname_9_digit != null ? v.location_nickname_9_digit : '',
      nick_name: v.nick_name != null ? v.nick_name : '',
      sez: v.sez != null && v.sez !== '' ? v.sez : (v.is_sez ? v.is_sez : '0'),
      state: v.state != null ? v.state : '',
      country_id: v.country_id != null ? v.country_id : '',
      company_id: v.company_id != null ? v.company_id : '',
    };
  }

  private filterAndMapCostCenters(costCenters: any[]): any[] {
    if (!costCenters || costCenters.length === 0) {
      return [];
    }
    const companyId = this._localStorageService.getEmpCompanyId();
    return costCenters
      .filter((v) => v.company_id == companyId)
      .map((v) => this.mapCostCenterRecord(v));
  }

  getUserDetails(id) {

    let requestObj = {
      "emp_id": id == undefined || id == null ? 0 : id,
      "hide_cc": "1",
    }
    let temp: any = [];
    temp = this.eesdesService.get('costcenters',localStorage.getItem('costcenters')) ? this.eesdesService.get('costcenters',localStorage.getItem('costcenters')) : [];
    // Only trust the cache if it actually holds cost centers for the CURRENT
    // company. After a company switch the cache can still contain the previous
    // company's rows (e.g. company_id 431 while the active company is 433); a
    // plain length check would wrongly skip the API and keep stale data.
    const currentCompanyId = this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId().toString() : '';
    const cacheMatchesCurrentCompany = temp.length > 0 &&
      temp.some((v) => v && v.company_id != null && v.company_id.toString() == currentCompanyId);
    if (cacheMatchesCurrentCompany) {
      this.isMultiple = this.eesdesService.get('isMultiple',localStorage.getItem('isMultiple')) == '1' ? true : false;
      if(this.page_url!='/all-notification')
      {
      this.getNotification();
      }
      this.checkSupportPopupForCachedUser(id);
      return;
    }
    this.costcenters = [];
    this.companiesArrray = [];
    //employees/ajax_getsingemp
    //employees/ajax_getsingemp_companies_details
    this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.empDetails = data;
            if (this.isSupportPopupDashboardPage()) {
              const pop_shown_date = this.resolveSupportPopupShowDate(this.empDetails.empdata.pop_show_date);
              const toggle = this.empDetails.support_popup_frequency == '1' ? true : false;
              const days = this.empDetails.support_popup_frequency_days ? this.empDetails.support_popup_frequency_days : 0;
              this.getSupportPopupConfig(pop_shown_date, toggle, days);
            }
            // if (this.empDetails.empdata.cost_centers)
            //   if (this.empDetails.empdata.cost_centers.length > 0) {
            //     this.costcenters = this.filterAndMapCostCenters(this.empDetails.empdata.cost_centers);
            //     this.costCenterStorageService.setCostCenters(this.costcenters);
            //     // send to last logout screen
            //   }
            this.isMultiple = false;
            this.empDetails.empdata.switch_companies_list=this.webService.convertNaN(this.empDetails.empdata.switch_companies_list);
           // console.log(this.empDetails.empdata.switch_companies_list);
            this.isMultiple=parseInt(this.empDetails.empdata.switch_companies_list) > 1?true:false;
            if (this.empDetails.empdata.companies) {
              if (this.empDetails.empdata.companies.length > 0) {
                this.companiesArrray = this.empDetails.empdata.companies.filter((v) => { return v.company_id == this._localStorageService.getEmpCompanyId() })
                localStorage.setItem('companies', this.eesdesService.set(JSON.stringify(this.companiesArrray)))
                        let j:any={}
                        j=this.companiesArrray.length>0?this.companiesArrray[0]:{};
                        localStorage.setItem("department_id", this.eesdesService.set(j.department?j.department:''));
                        localStorage.setItem("department_name", this.eesdesService.set(j.department_name?j.department_name:''));
                        localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image?j.profile_image:''));
              }
              if (parseInt(this.empDetails.empdata.switch_companies_list) > 1) {
               // this.isMultiple = true;
                this.companies = this.empDetails.empdata.companies;
              }
              else {
                //this.isMultiple = false;
              }
            }
          } else if (data.status) {
            //this.isMultiple = false;
          }
          localStorage.setItem('isMultiple',this.eesdesService.set(this.isMultiple ? '1' : '0'));

          this.getNotification();


          if (this.isMultiple && this.companyName == "TYA Admin") {
            this.webService.redirectURL('/my-companies');

            this.toasterService.pop("info", "Info", "Select Company First!");
            return;
          }

        }, error => {
        }
      );

  }

  checkSupportPopupForCachedUser(id: any) {
    if (!this.isSupportPopupDashboardPage()) {
      return;
    }
    const requestObj = {
      "emp_id": id == undefined || id == null ? 0 : id
    };

    const supportPopupUserRequest = this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj);
    if (!supportPopupUserRequest) {
      return;
    }

    supportPopupUserRequest.subscribe(
        data => {
          if (data.status && data.empdata) {
            const popShownDate = this.resolveSupportPopupShowDate(data.empdata.pop_show_date);
            const toggle = data.support_popup_frequency == '1';
            const days = data.support_popup_frequency_days ? data.support_popup_frequency_days : 0;
            this.getSupportPopupConfig(popShownDate, toggle, days);
          }
        },
        error => {
        }
      );
  }

   hasUnicode (str) {
     if(str.length>0)
     {
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 175){console.log(str[i]); return true;}
    }
  }
    return false;
}
  vendorDetails: any
  getVendorDetails(id) {

    let requestObj = {
      "vendor_id": id == undefined || id == null ? 0 : id,
    }
    let temp: any = [];
    temp = this.eesdesService.get('costcenters',localStorage.getItem('costcenters')) ? this.eesdesService.get('costcenters',localStorage.getItem('costcenters')) : [];
    if (temp.length > 0) {
      this.isMultiple = this.eesdesService.get('isMultiple',localStorage.getItem('isMultiple')) == '1' ? true : false;
      this.getNotification();
      this.in_progress=false;
      return;
    }
    this.costcenters = [];
    this.companiesArrray = [];
    //employees/ajax_getsingvendor
    //Vendor_management/ajax_getsingvendor_companies_details
     this.webService.commonPostMethod('Vendor_management/ajax_getsingvendor', requestObj).
      subscribe(
        data => {
          if (data.status) {
             data.vendordata=data.empdata?data.empdata:data.vendordata;
            this.vendorDetails = data;
            // if (this.vendorDetails.vendordata.cost_centers)
            //   if (this.vendorDetails.vendordata.cost_centers.length > 0) {
            //     this.costcenters = this.filterAndMapCostCenters(this.vendorDetails.vendordata.cost_centers);
            //     this.costCenterStorageService.setCostCenters(this.costcenters);
            //     // send to last logout screen
            //   }
            this.isMultiple = false;
            this.vendorDetails.vendordata.switch_companies_list=this.webService.convertNaN(this.vendorDetails.vendordata.switch_companies_list);
           // console.log(this.vendorDetails.vendordata.switch_companies_list);
            this.isMultiple=parseInt(this.vendorDetails.vendordata.switch_companies_list) > 1?true:false;
            if (this.vendorDetails.vendordata.companies) {
              if (this.vendorDetails.vendordata.companies.length > 0) {
                this.companiesArrray = this.vendorDetails.vendordata.companies.filter((v) => { return v.company_id == this._localStorageService.getEmpCompanyId() })
                localStorage.setItem('companies', this.eesdesService.set(JSON.stringify(this.companiesArrray)))
                localStorage.setItem('is_completed',this.eesdesService.set(this.vendorDetails.vendordata.is_completed));
                this.is_completed=this.vendorDetails.vendordata.is_completed;
                if(this.vendorDetails.vendordata.is_completed=='0' && this.company_setup.is_update_action_mand_for_incom_ven_profile=='1')
                {
                // this.getMenuList();
                this.webService.redirectURL('vendorprofile')
                }

              }
              if (parseInt(this.vendorDetails.vendordata.switch_companies_list) > 1) {
               // this.isMultiple = true;
                this.companies = this.vendorDetails.vendordata.companies;
              }
              else {
                //this.isMultiple = false;
              }
            }
          } else if (data.status) {
            //this.isMultiple = false;
          }
          localStorage.setItem('isMultiple', this.eesdesService.set(this.isMultiple ? '1' : '0'));

          this.getNotification();
          this.in_progress=false;

          if (this.isMultiple && this.companyName == "TYA Admin") {
            this.webService.redirectURL('/my-companies');

            this.toasterService.pop("info", "Info", "Select Company First!");
            return;
          }

        }, error => {
          this.in_progress=false;
        }
      );

  }





  navigate(url: any, parentMenu: string, isMain: boolean, project: string) {
    let t: any = { "action_type": 'new' }
    if (url != 'test-direct-invoice' || url != 'direct-invoice' ) {
      // localStorage.setItem('direct-invoice', JSON.stringify(t));
      localStorage.setItem('direct-invoice', this.eesdesService.set(JSON.stringify(t)))
      localStorage.setItem('recurring-direct-invoice', this.eesdesService.set(JSON.stringify(t)))

    }
    if (url != 'sales-invoice') {
      // localStorage.setItem('sales-invoice', JSON.stringify(t));
      localStorage.setItem('sales-invoice', this.eesdesService.set(JSON.stringify(t)))
    }
    if (url != 'rejected-invoice') {
      // localStorage.setItem('rejected-invoice', JSON.stringify(t));
      localStorage.setItem('rejected-invoice', this.eesdesService.set(JSON.stringify(t)))
    }
    localStorage.setItem("dashboardAction_isTotal", this.webService.set('1','dashboardAction_isTotal'));

    if (isMain && (url=='#'||url=='/#'||url=='new-menu'||url=='/new-menu')) return;
    if(this.eesdesService.get('is_vendor_login',localStorage.getItem('is_vendor_login'))=='1')
    {
    if(this.eesdesService.get('is_completed',localStorage.getItem('is_completed'))=='0' && url!='/vendorprofile' && this.company_setup.is_update_action_mand_for_incom_ven_profile=='1')
    {
this.toasterService.pop('warning','Warning','You are not allowed to access this page. first complete your profile');

return false;
    }
  }
    const projectKey = (project || '').toString().trim().toLowerCase();
    let redirectUrl = '/#';
    let origin = window.location.origin;
    if (projectKey == 'master' || projectKey == 'reports' || projectKey == 'settings') {
      this.openUpgradedProject(projectKey, url, origin, redirectUrl);
      return;
    } else if (projectKey == 'mapping') {
      redirectUrl = origin + '/mapping' + redirectUrl + url;
    } else if (projectKey == 'finance') {
      redirectUrl = origin + '/finance' + redirectUrl + url;
    }
    else if (projectKey == 'project_management') {
      redirectUrl = origin + '/project_management' + redirectUrl + url;
    }
    else if (projectKey == 'help_desk') {
      redirectUrl = origin + '/help_desk' + redirectUrl + url;
    }
    else if (projectKey == 'compliance') {
      redirectUrl = origin + '/compliance' + redirectUrl + url;
    }
    else if (projectKey == 'other_operation') {
      redirectUrl = origin + '/other_operation' + redirectUrl + url;
    } else if (projectKey == 'asset_management') {
      redirectUrl = origin + '/asset_management' + redirectUrl + url;
    } else if (projectKey == 'o2c') {
      redirectUrl = origin + '/o2c' + redirectUrl + url;
    } else if (projectKey == 'operation' || projectKey == 'tya-operation') {
      this.webService.openWithLatestModernDefault(url, () => {
        window.location.href = origin + '/#' + url;
      });
      return;
    }
     else if (projectKey == 'crm') {
      redirectUrl = origin + '/crm' + redirectUrl + url;
    }
    else if (projectKey == 'advance-reporting') {
      redirectUrl = origin + '/advance-reporting' + redirectUrl + url;
    }
    else {
      if (url == '#' || !url) return;
      this.webService.redirectURL(url);
      return;
    }
    window.location.href = redirectUrl;



  }

  /** Supported master, report, and settings pages open in the modern folder when the company flag is on. */
  private openUpgradedProject(projectKey: string, url: any, origin: string, hashPrefix: string): void {
    var folder = '/settings';
    if (projectKey == 'master') {
      folder = '/master';
    } else if (projectKey == 'reports') {
      folder = '/report';
    }
    var classicHref = origin + folder + hashPrefix + url;
    this.webService.openProjectWithLatestModernDefault(projectKey, url, function () {
      window.location.href = classicHref;
    });
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "250px";
    document.getElementById("mySidenav").style.zIndex = "9999999999";
    this.isOpened = false;
    this.isclosed = true;
    let elem: any = (<HTMLElement>document.querySelector('.sublist-ul.active'));
    if (elem) {
      elem.style.display = 'block'
    }
  }

  closeNav() {
    let w = window.innerWidth;
    let dynamicWidth = w < 768 ? 0: 60;
    document.getElementById("mySidenav").style.width = `${dynamicWidth}px`;
    document.getElementById("mySidenav").style.zIndex = "1000";
    this.isOpened = true;
    this.isclosed = false;
    let elem: any = (<HTMLElement>document.querySelector('.sublist-ul.active'));
    if (elem) {
      elem.style.display = 'none'
    }
  }
  getModule(url) {
    let temp: any = [];
    temp = this.arrayForSearch.filter((v) => { return v.url == url })
    return temp[0] ? temp[0] : '';
  }

  loadAskQueryModules() {
    const menus: any[] = this.menuList && this.menuList.length
      ? this.menuList
      : (this.eesdesService.get('menus', localStorage.getItem('menus')) || []);

    this.askQueryModules = [];
    for (let i of menus) {
      if (i.id && i.menuitemname) {
        const moduleId = String(i.id);
        // Avoid duplicate ids overwriting / wrong name lookup
        if (!this.askQueryModules.some((v) => { return String(v.id) === moduleId; })) {
          this.askQueryModules.push({
            id: moduleId,
            name: i.menuitemname
          });
        }
      }
    }
  }

  onAskQueryModuleChange() {
    const selected = this.askQueryModules.find((v) => {
      return String(v.id) === String(this.askQueryData.moduleId);
    });
    if (selected && selected.name) {
      this.askQueryData.moduleName = selected.name;
    }
  }

  toggleAskQueryModuleDropdown(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.isAskQueryModuleOpen = !this.isAskQueryModuleOpen;
  }

  selectAskQueryModule(module: any) {
    this.askQueryData.moduleId = module && module.id != null ? String(module.id) : '';
    this.askQueryData.moduleName = module && module.name ? module.name : '';
    this.isAskQueryModuleOpen = false;
  }
  logout() {
    this.logoutService.logout(this.arrayForSearch, 'normal');
  }
  gotoUp() {
    window.scrollTo(0, 0);

  }
  gotoDown() {
    let element = document.getElementById("body");
    let x = element.clientHeight;
    let y = element.clientWidth;
    window.scrollTo(y, y);
  }

  switchCompany() {
    localStorage.setItem("dashboardAction", "");
    localStorage.setItem('view_past_po_data', this.eesdesService.set(JSON.stringify({})))
    localStorage.setItem("dashboardAction_isTotal", this.webService.set('1','dashboardAction_isTotal'));

    this.webService.redirectURL('/my-companies');

  }
  @HostListener('document:click')
  closeCompanySwitcherOnOutsideClick() {
    this.isCompanySwitcherOpen = false;
  }

  toggleCompanySwitcher(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.isCompanySwitcherOpen = !this.isCompanySwitcherOpen;
    if (this.isCompanySwitcherOpen) {
      this.setCompanySwitcherActiveIndex();
      this.makeFocus('company_switch_search');
    }
  }

  onCompanySwitcherTriggerKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();
      if (!this.isCompanySwitcherOpen) {
        this.isCompanySwitcherOpen = true;
        this.setCompanySwitcherActiveIndex();
        this.makeFocus('company_switch_search');
      }
    }
  }

  onCompanySwitcherKeydown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();
      this.moveCompanySwitcherActiveIndex(1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      event.stopPropagation();
      this.moveCompanySwitcherActiveIndex(-1);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.selectActiveCompanyFromSwitcher(event);
    } else if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.isCompanySwitcherOpen = false;
      this.companyData.searchComp = '';
    } else {
      event.stopPropagation();
    }
  }

  onCompanySearchChange() {
    this.companySwitcherActiveIndex = 0;
  }

  getFilteredCompanyList() {
    if (!this.companyData || !this.companyData.list) {
      return [];
    }
    if (!this.companyData.searchComp) {
      return this.companyData.list;
    }
    let query = this.companyData.searchComp.toLowerCase();
    return this.companyData.list.filter((company) => {
      return company.name && company.name.toLowerCase().indexOf(query) > -1;
    });
  }

  setCompanySwitcherActiveIndex() {
    let companyList = this.getFilteredCompanyList();
    let selectedIndex = companyList.findIndex((company) => { return company.id == this.companyData.company_id });
    this.companySwitcherActiveIndex = selectedIndex > -1 ? selectedIndex : 0;
  }

  moveCompanySwitcherActiveIndex(step: number) {
    let companyList = this.getFilteredCompanyList();
    if (!companyList.length) {
      this.companySwitcherActiveIndex = 0;
      return;
    }
    this.companySwitcherActiveIndex = this.companySwitcherActiveIndex + step;
    if (this.companySwitcherActiveIndex < 0) {
      this.companySwitcherActiveIndex = companyList.length - 1;
    } else if (this.companySwitcherActiveIndex >= companyList.length) {
      this.companySwitcherActiveIndex = 0;
    }
  }

  selectActiveCompanyFromSwitcher(event?: any) {
    let companyList = this.getFilteredCompanyList();
    let selectedCompany = companyList[this.companySwitcherActiveIndex];
    if (selectedCompany) {
      this.selectCompanyFromSwitcher(selectedCompany, event);
    }
  }

  selectCompanyFromSwitcher(company: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    if (!company) {
      return;
    }
    if (company.id == this.companyData.company_id) {
      this.companyData.searchComp = '';
      this.isCompanySwitcherOpen = false;
      return;
    }
    this.companyData.company_id = company.id;
    this.companyData.searchComp = '';
    this.isCompanySwitcherOpen = false;
    this.setCompany({ value: company.id });
  }

  getSelectedCompanyName() {
    if (!this.companyData || !this.companyData.list) {
      return '';
    }
    let selectedCompany = this.companyData.list.filter((v) => { return v.id == this.companyData.company_id })[0];
    return selectedCompany ? selectedCompany.name : '';
  }

  makeFocus(id: string) {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.focus();
      }
    }, 300);
  }
  validateUser() {
    if (this._localStorageService.getEmpCompanyId() == "" || this._localStorageService.getEmpCompanyId() == undefined || this._localStorageService.getEmpCompanyId() == null) {
      this.toasterService.pop("info", "Info", "Set Company First");
      this.webService.redirectURL('/my-companies');

    }
  }

  goHome() {
    localStorage.setItem("dashboardAction", "");
    localStorage.setItem('view_past_po_data', this.eesdesService.set(JSON.stringify({})))
    localStorage.setItem("dashboardAction_isTotal", this.webService.set('1','dashboardAction_isTotal'));

     this.router.navigateByUrl(applyUiModeToRedirectPath('/dashboard'));


  }

  // showSearchBox() {
  //   if (this.isSearch) {
  //     this.isSearch = false;
  //   }
  //   else {
  //     this.isSearch = true;
  //   }
  // }

  serachDetails(event) {
    this.searchListItems = [];
  }

  unreadNotifications: any = [];
  totalNotification: any = [];
  last_notification_count:any='0';
  is_new_login:any='0';
  getNotification() {
    this.notificationList = [];
    let requestObj = {
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      "userid": this._localStorageService.getUserId() ? this._localStorageService.getUserId() : 0,
      "page_no": "0",
      "record_per_page": '10',

    }
   this.last_notification_count=this.eesdesService.get('total_download_notification',localStorage.getItem('total_download_notification'))?this.eesdesService.get('total_download_notification',localStorage.getItem('total_download_notification')):'0';
   this.is_new_login=this.eesdesService.get('is_new_login',localStorage.getItem('is_new_login'))?this.eesdesService.get('is_new_login',localStorage.getItem('is_new_login')):'0';

   let count:number=0;

    this.webService.commonPostMethod('/notification_employee/ajax_getallnotification', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.notificationList = data.response;
            this.totalNotification = data.response.filter((v) => { return v.read_indicator == '1' });
            this.unreadNotifications = []
            let index: number = 1;
            if (this.notificationList.length > 0) {
              let temp: any = [];
              temp = this.notificationList;
              temp.filter((v) => { return v.read_indicator == '1' });
              this.unreadNotifications = temp.slice(0, 10);
              count=this.notificationList.filter((x)=>{return x.target!=''&&x.target!='' && x.read_indicator == '1'}).length;


            }
            if(parseInt(this.is_new_login)>0)
          {
            if(count>this.last_notification_count)
            {
            this.playAudio();
            this.toasterService.pop('info','Info','New Download Notification Found');
            document.getElementById('noti_list').click();
          }
          localStorage.setItem('total_download_notification',this.eesdesService.set(count.toString()));

          }
          localStorage.setItem('is_new_login',this.eesdesService.set('1'))

          }
          else {
            data.message = data.message ? data.message : '';
            if (data.message != '' && data.message != undefined && this.companyName != 'TYA Admin') {
              if (data.message == "Authentication Faild" || data.message == "authentication faild") {
                this.toasterService.pop('warning', 'Warning', 'Hey We Found Some Wrong Operation...!');
                this.logout();
              }
            }
          }
        }, error => {

        }
      );
  }

  formatNotificationMessage(msg: string): string {
    if (!msg) { return ''; }
    return msg.replace(/(https?:\/\/[^\s]+)/g, (url) => {
      const href = url.replace(/\/master\/(?!#)/, '/master/#/');
      return `<a href="${href}" style="color:#1a73e8;text-decoration:underline;word-break:break-all;">${url}</a>`;
    });
  }

  goNotification(url) {
    this.router.navigateByUrl(applyUiModeToRedirectPath(url));

  }
  seeMore(url) {
    this.router.navigateByUrl(applyUiModeToRedirectPath(url));

  }

  markRead(id) {
    let requestObj = {
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      "userid": this._localStorageService.getUserId() ? this._localStorageService.getUserId() : 0,
      "id": id,
      "status": 0,
    }
    this.webService.commonPostMethod('/notification_employee/ajax_update_read_status', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.getNotification();
          }
          else {
            this.getNotification();
          }

        }, error => {
          this.toasterService.pop("error", "Error", "Something Went wrong");
          this.getNotification();
        }
      );
  }
  getProject(url) {
    let temp: any = [];
    temp = this.arrayForSearch.filter((v) => { return v.url == url })
    return temp[0].project ? temp[0].project : '';

  }
  getSearchedValue() {
    localStorage.setItem("dashboardAction", "");
  localStorage.setItem('view_past_po_data', this.eesdesService.set(JSON.stringify({})))
    localStorage.setItem("dashboardAction_isTotal", this.webService.set('1','dashboardAction_isTotal'));

    let redirectUrl = '/#';
    let origin = window.location.origin;
    let url = this.searchedItem;
    let project: any = "";
    if(this.eesdesService.get('is_vendor_login',localStorage.getItem('is_vendor_login'))=='1')
    {
    if(this.eesdesService.get('is_completed',localStorage.getItem('is_completed'))=='0' && url!='/vendorprofile' && this.company_setup.is_update_action_mand_for_incom_ven_profile=='1')
    {
this.toasterService.pop('warning','Warning','You are not allowed to access this page. first complete your profile');

return false;
    }
  }
    project = (this.getProject(this.searchedItem) || '').toString().trim().toLowerCase();
    if (project == 'master' || project == 'reports' || project == 'settings') {
      this.openUpgradedProject(project, url, origin, redirectUrl);
      return;
    } else if (project == 'mapping') {
      redirectUrl = origin + '/mapping' + redirectUrl + url;
      window.location.href = redirectUrl;
    } else if (project == 'finance') {
      redirectUrl = origin + '/finance' + redirectUrl + url;
      window.location.href = redirectUrl;
    }
    else if (project == 'project_management') {
      redirectUrl = origin + '/project_management' + redirectUrl + url;
      window.location.href = redirectUrl;
    }
    else if (project == 'help_desk') {
      redirectUrl = origin + '/help_desk' + redirectUrl + url;
      window.location.href = redirectUrl;
    }
    else if (project == 'compliance') {
      redirectUrl = origin + '/compliance' + redirectUrl + url;
      window.location.href = redirectUrl;
    }
    else if (project == 'other_operation') {
      redirectUrl = origin + '/other_operation' + redirectUrl + url;
      window.location.href = redirectUrl;
    } else if (project == 'asset_management') {
      redirectUrl = origin + '/asset_management' + redirectUrl + url;
      window.location.href = redirectUrl;
    } else if (project == 'o2c') {
      redirectUrl = origin + '/o2c' + redirectUrl + url;
      window.location.href = redirectUrl;
    } else if (project == 'operation' || project == 'tya-operation') {
      this.webService.openWithLatestModernDefault(url, () => {
        window.location.href = origin + '/#' + url;
      });
      return;
    }
     else if (project == 'crm') {
       redirectUrl = origin + '/crm' + redirectUrl + url;
      window.location.href = redirectUrl;
    }
    else if (project == 'advance-reporting') {
      redirectUrl = origin + '/advance-reporting' + redirectUrl + url;
     window.location.href = redirectUrl;
   }
    else {
      redirectUrl = url;
      this.webService.redirectURL(redirectUrl);

    }
  }

  notificationIdDelete: any = '';
  showNotification(id) {
    //  document.getElementById('notificationModal').style.display = "block";
    this.notificationIdDelete = id;
  }

  hideNotification() {
    document.getElementById('notificationModal').style.display = "none";
  }

  showSearch() {
    document.getElementById('searchModal').style.display = "block";
    this.webService.makeFocusById("searchId");
  }

  hideSearch() {
    document.getElementById('searchModal').style.display = "none";
  }

  deleteNotifiction() {
    let id: any = {
      "id": this.notificationIdDelete,
      "status": "0"
    }
    this.webService.commonPostMethod('/notification_employee/ajax_delete_status', id).
      subscribe(
        data => {
          if (data.status == true) {
            this.hideNotification();
            this.getNotification();
          }
        }, error => {
          this.toasterService.pop('success', 'Success', "something went wrong");
        }
      );
  }

  isMenuIconOpened: boolean = false;
  openMenuNav() {
    this.isCompanySwitcherOpen = false;
    const menuNav = document.getElementById('menuNav');
    if (!menuNav) {
      return;
    }
    menuNav.style.width = '150px';
    if (this.isMultiple && this.companyData.list.length > 0) {
      menuNav.classList.add('menunav-below-company');
    } else {
      menuNav.classList.remove('menunav-below-company');
    }
    this.isMenuIconOpened = true;
  }

  closeMenuNav() {
    const menuNav = document.getElementById('menuNav');
    if (!menuNav) {
      return;
    }
    menuNav.style.width = '0';
    menuNav.classList.remove('menunav-below-company');
    this.isMenuIconOpened = false;
  }

  navigateProfile() {
    // this.webService.redirectURL('/my-profile');
    window.location.href=window.location.origin+"/settings"+"/#/"+"/my-profile";
  }
  navigatePasswordReset() {
    this.webService.redirectURL('/reset-password');

  }
  download(d) {
    window.open(d.target, '_blank');
  }
  loadResponse: any = [];
  showProgress() {
    let obj = {
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
    }
    this.webService.commonPostMethod("/Bulk_progress/get_progress_report", obj).
      subscribe(
        data => {
          if (data.status) {
            this.loadResponse = data.response;
            for (let x of this.loadResponse) {
              for (let y of x.response) {
                y.process_name = y.process_name ? y.process_name : 'Process ';
                y.totalPercent = (y.total_records * 100) + 'px';
                y.pendingPercent = (y.completed * 100) + 'px';
              }
            }
            if (this.flaglist) {
              setTimeout(() => {
                this.showProgress();
              }, 6000);
            }
          }
          else {
          }
        },
        error => {

        }
      );
  }

  flaglist: boolean = false;
  startProcess(flag: boolean) {
    if (flag) {
      this.showProgress();
      document.getElementById("progressSidenav").style.width = "450px";
      document.getElementById("showProgressModel").style.display = "block";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    } else {
      document.getElementById("progressSidenav").style.width = "0";
      document.getElementById("showProgressModel").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
    this.flaglist = flag
  }
  removeProcess(data) {

  }
  goToLastUrl(project, last_logout_url, ) {
    let redirectUrl = '/#';
    let origin = window.location.origin;
    if (project == 'master') {
      redirectUrl = origin + '/master' + last_logout_url;
    } else if (project == 'reports') {
      redirectUrl = origin + '/report' + last_logout_url;
    } else if (project == 'mapping') {
      redirectUrl = origin + '/mapping' + last_logout_url;
    } else if (project == 'finance') {
      redirectUrl = origin + '/finance' + last_logout_url;
    }

    else {
      if (last_logout_url == '#' || !last_logout_url) return;
      this.router.navigate([redirectUrl]);

      return;
    }
    window.location.href = redirectUrl;


  }

  IsRoleChanged() {
    if (GroupMailedInvoiceCompanyContextService.shouldSkipRoleCheck()) {
      return;
    }
    let obj = {
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      'user_id': this._localStorageService.getUserId(),
      'user_role_id': this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) : '0'
    }
    if (obj.company_id == '0') {
      return;
    }
    if(obj.user_role_id=='vendor')
    {
        return;
    }
    this.is_active=false;
    this.webService.commonPostMethod("Employees/is_employee_role_exist", obj).
      subscribe(
        data => {
          if (data.status) {
          }
          else {
            this.is_active=true;
            this.already_active_msg=data.message;
            this.showLogoutIssue(true);
          }
        },
        error => {
        }
      );

  }
  ConfirmLogout()
  {
    try{

      window.localStorage.clear();
      window.sessionStorage.clear()
      window.location.href = window.location.origin + '/#/login';
      this.showLogoutIssue(false);
    }
    catch(err)
    {
      console.log(err)
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = window.location.origin + '/#/login';
    }
  }
  showLogoutIssue(flag: boolean) {
    if (flag) {
      document.getElementById("IssueSidenavUserSession").style.width = "35%";
      document.getElementById("showIssueModelUserSession").style.display = "block";
      document.getElementById("header").style.zIndex = "9999999";

      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    } else {
      document.getElementById("IssueSidenavUserSession").style.width = "0";
      document.getElementById("showIssueModelUserSession").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
      document.getElementById("header").style.zIndex = "999999999";
    }
  }
  downloadData(d)
  {
    if(d.target!='' && d.target!=undefined)
    {
      window.location.href=d.target;
    }
  }
  playAudio() {
    let audio = new Audio();
    audio.src = "../../../assets/audio/new.mp3";
    audio.load();
    audio.play();
  }

  issuelist: boolean = false;
  showIssue(flag: boolean) {
    if (flag) {
      document.getElementById("IssueSidenav").style.width = "50%";
      document.getElementById("showIssueModel").style.display = "block";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
      this.generateTickcode();
    } else {
      document.getElementById("IssueSidenav").style.width = "0";
      document.getElementById("showIssueModel").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
    this.issuelist = flag
  }
  ticktData:any={};
  generateTickcode() {
    this.ticktData={
      'ticket_code':'',
      "project":'operation',
      "category":'Operation',
      "email":this._localStorageService.getUserEmail()?this._localStorageService.getUserEmail():'',
      "priority":'1',
      "subject":'',
      "description":'',
      "attachments":[],

    }
    let obj = {
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      'user_id': this._localStorageService.getUserId(),
      'user_role_id': this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) : '0'
    }
    if (obj.company_id == '0') {
      return;
    }

    this.webService.commonPostMethod("/ticket/Raise_ticket/generate_ticket_code", obj).
      subscribe(
        data => {
          if (data.status) {
            this.ticktData.ticket_code=data.response;


          }
          else {
            this.toasterService.pop('error','Error',data.message);

          }
        },
        error => {
          this.toasterService.pop('error','Error','Something Went Wrong')

        }
      );

  }
  uploadedFile: any = '';
  min_size: number = 0;
  max_size: number = 50;
  changeListener(elem: any): void {
    this.readThis(elem.target);
  }
  fileType: any = ''
  fileName: any = '';
  file: any = '';
  displayFile: any = '';
  readThis(inputValue: any): void {
    this.fileType = "";
    this.uploadedFile = "";
    this.displayFile = "";
    this.fileName = '';
    var file: File = inputValue.files[0];
    this.fileType = this.webService.getFileExtension(file.name);
    this.fileName = this.webService.getFilename(file.name);
    this.file = file.name;


    if (!this.checkValidFileType(this.fileType)) {
      this.toasterService.pop("info", "Info", "File Type Should Be Valid");
      return;
    }
    var myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.uploadedFile = myReader.result;
      this.uploadImg();
    }
    myReader.readAsDataURL(file);
  }
  savedFiles: any = [];
  isUploading:boolean=false;
  uploadImg() {
    this.isUploading = true;
    let requestObj = {
      "base64": this.uploadedFile,
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      "file_type": this.fileType,
      "file_name": this.fileName,
      "attachment": this.file,
    }
    this.webService.commonPostMethod("ticket/Raise_ticket/ticket_attachment", requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.uploadedFile = data.response;
            this.displayFile = data
            this.savedFiles.push({
              "url": this.displayFile.url,
              "name": this.uploadedFile,
              "attachment": this.file,
              "display": this.displayFile.url,
              "fileImage": this.displayFile.url,
              "filename": this.fileName,
              "filetype": this.fileType,
              "iconclass": this.webService.getFileIcon(this.fileType),
            });
            this.fileType = "";
            this.uploadedFile = "";
            this.displayFile = "";
            this.fileName = '';
            this.file = '';
          }
          this.file = '';
          this.fileType = "";
          this.uploadedFile = "";
          this.displayFile = "";
          this.fileName = '';
          this.isUploading = false;
        },
        error => {
          this.toasterService.pop('error', 'Error', "Failed to upload image");
          this.isUploading = false;
        }
      );
  }
  removeImage(i) {
    this.savedFiles.splice(i, 1)
  }
  staticAcceptedFileArray:any=[
    {'id': '1', 'type': 'png'},{'id': '2', 'type': 'jpg'},{'id': '3', 'type': 'jpeg'},{'id': '4', 'type': 'gif'},{'id': '5', 'type': 'bmp'},
    {'id': '6', 'type': 'tif'},{'id': '7', 'type': 'tiff'},{'id': '8', 'type': 'txt'},{'id': '9', 'type': 'doc'},{'id': '10', 'type': 'docx'},
    {'id': '11', 'type': 'rtf'},{'id': '12', 'type': 'wks'},{'id': '13', 'type': 'wps'},{'id': '14', 'type': 'wpd'},{'id': '15', 'type': 'xlr'},
    {'id': '16', 'type': 'xls'},{'id': '17', 'type': 'xlsx'},{'id': '18', 'type': 'ppt'},{'id': '19', 'type': 'pptx'},{'id': '20', 'type': 'pps'},
    {'id': '21', 'type': 'csv'},{'id': '22', 'type': 'pdf'},{'id': '23', 'type': 'msg'}
  ];
  checkValidFileType(type) {
    type = type.toLowerCase() ? type.toLowerCase() : '';
    let status = false;
    let extensionArray = [];
    let acceptedArray = [];
    acceptedArray = this.staticAcceptedFileArray?this.staticAcceptedFileArray:[];
    extensionArray = this.company_setup.fileExtensionList?this.company_setup.fileExtensionList:[];
    if(extensionArray.length > 0){
      for(let i of extensionArray){
        if(i.is_visible_file_extensions){
          if(type == i.extension){
            status = true;
          }
        }
      }
    }
    if(extensionArray.length == 0){
      for(let i of acceptedArray){
        if(type == i.type){
          status = true;
        }
      }
    }
    return status;
  }
  buttonProgressing:boolean=false;
  submitTickt() {
    if(this.ticktData.ticket_code==''||this.ticktData.ticket_code==undefined)
    {
      this.toasterService.pop('info','Info','Ticket Code not Found');
      return;
    }
    if(this.ticktData.subject==''||this.ticktData.subject==undefined)
    {
      this.toasterService.pop('info','Info','Ticket Subject not Found');
      return;
    }
    if(this.ticktData.description==''||this.ticktData.description==undefined)
    {
      this.toasterService.pop('info','Info','Ticket Description not Found');
      return;
    }
    let attachments: any = [];
    for (let x of this.savedFiles) {
      attachments.push({
        "attachment_url": x.url,
        "attachment_name": x.filename,
        "attachment": x.name,
        "attchement_type": x.filetype,
      })
    }

    let obj = {
      "attachments":attachments?attachments:'',
      "ticket_code": this.ticktData.ticket_code?this.ticktData.ticket_code:'',
      "raise_by": this._localStorageService.getUserId(),
      "email": this.ticktData.email?this.ticktData.email:'',
      "project": this.ticktData.project?this.ticktData.project:'',
      "category": this.ticktData.category?this.ticktData.category:'',
      "priority": this.ticktData.priority?this.ticktData.priority:'',
      "subject": this.ticktData.subject?this.ticktData.subject:'',
      "description": this.ticktData.description?this.ticktData.description:'',
      "added_by": this._localStorageService.getUserId(),
      "company_id":this.eesdesService.get('company_id',localStorage.getItem('company_id'))?this.eesdesService.get('company_id',localStorage.getItem('company_id')):'0'
    }
    if (obj.company_id == '0') {
      return;
    }
   this.buttonProgressing=true;
    this.webService.commonPostMethod("ticket/Raise_ticket/insert_raise_ticket", obj).
      subscribe(
        data => {
          if (data.status) {
            this.toasterService.pop('success','Success',data.message);
            // this.showIssue(true);
          }
          else {
           this.toasterService.pop('error','Error',data.message)
          }
          this.buttonProgressing=false;

        },
        error => {
          this.toasterService.pop('error','Error','Something Went Wrong')
          this.buttonProgressing=false;

        }
      );
      }

  theme()
  {
    this.isTrue=false;
    console.log(this.isTrue);
  }
  setTheme(themeType){
    this.isTrue=true;
    // console.log(this.isTrue);

    if(themeType!='')
    {
    if(themeType=='light-theme')
    {
      localStorage.setItem('themetype',this.eesdesService.set('light-theme'));
      localStorage.setItem('theme-backrgound',this.eesdesService.set('white'));
      localStorage.setItem('theme-color',this.eesdesService.set('black'));
    }
    else if(themeType=='dark-theme')
{
  localStorage.setItem('themetype',this.eesdesService.set('dark-theme'));
  localStorage.setItem('theme-backrgound',this.eesdesService.set('black'));
  localStorage.setItem('theme-color',this.eesdesService.set('white'));
}
else
{
  localStorage.setItem('themetype',this.eesdesService.set('default-theme'));
  localStorage.setItem('theme-backrgound',this.eesdesService.set('#035168'));
  localStorage.setItem('theme-color',this.eesdesService.set('white'));
}
    }
let background:any=this.eesdesService.get('theme-backrgound',localStorage.getItem('theme-backrgound'))?this.eesdesService.get('theme-backrgound',localStorage.getItem('theme-backrgound')):'#035168';
let color:any=this.eesdesService.get('theme-color',localStorage.getItem('theme-color'))?this.eesdesService.get('theme-color',localStorage.getItem('theme-color')):'white';
// console.log(document.getElementById('menu-ul'));
if(document.getElementById('menu-ul')!=null)
{
    document.getElementById('mySidenav').style.background=background;
    document.getElementById('menu-ul').style.background=background;
    document.getElementById('mySidenav').style.color=color;
    document.getElementById('menu-ul').style.color=color;
}
  }
  goTo()
  {
    let page_url: any =window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    window.open("https://www.tyasuite.com/community?page="+page_url+"&user="+this._localStorageService.getUserId()+"&company="+this._localStorageService.getEmpCompanyId(),"_new")
  }
  forAdminTheme() {
    this.isTrue=true;
    if(document.getElementById('mySidenav')!=null)
    {
    document.getElementById('mySidenav').style.background=this.companyThemeBlockColor ? this.companyThemeBlockColor : "#035168";
    }
    if(document.getElementById('menu-ul')!=null)
    {
    document.getElementById('menu-ul').style.background=this.companyThemeBlockColor ? this.companyThemeBlockColor : "#035168";
    }
    if(document.getElementById('mySidenav')!=null)
    {
    document.getElementById('mySidenav').style.color=this.CompanyThemetextColor ? this.CompanyThemetextColor : "#FFFFFF";
    }
    if(document.getElementById('menu-ul')!=null)
    {
    document.getElementById('menu-ul').style.color=this.CompanyThemetextColor ? this.CompanyThemetextColor : "#FFFFFF";
    }
  }
  checkBrowsers()
{
  let name:any=''
  if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) {
    name= 'Opera';
} else if(navigator.userAgent.indexOf("Chrome") != -1 ) {
    name= 'Chrome';
} else if(navigator.userAgent.indexOf("Safari") != -1) {
    name= 'Safari';
} else if(navigator.userAgent.indexOf("Firefox") != -1 ){
    name= 'Firefox';
} else if((navigator.userAgent.indexOf("MSIE") != -1 )) {
    name= 'IE';//crap
} else {
    name= 'Unknown';
}
let list:any=Array.isArray(this.eesdesService.get('BList',localStorage.getItem('BList')))?this.eesdesService.get('BList',localStorage.getItem('BList')):[];
 list.push(name);
 localStorage.setItem('BList',this.eesdesService.set(JSON.stringify(Array.from(new Set(list)))))
//  console.log(Array.from(new Set(list)))
}
detectMob() {
  let cls:any='sidenav_progressLogout'
  if (( window.innerWidth <= 800 ) && ( window.innerHeight <= 700 ) )
  {
    cls=cls+" sidenav_progressMobile"
  }
  if(this.is_active)
  {
    cls=cls+" sideProClass"
  }
  if(!this.is_active)
  {
    cls=''
  }
  return cls
}
companyData:any={is_multiple:false,list:[],data:{},searchComp:'',company_id:this._localStorageService.getEmpCompanyId()}
previousCompanyIdBeforeSwitch: string = '';
isCompanySwitcherOpen: boolean = false;
companySwitcherActiveIndex: number = 0;
getCompanies() {
  if (this.isMultiple)
  {
  let requestObj = {
    "emp_id": this._localStorageService.getUserId(),
    "company_id":'0',
  }
  //employees/ajax_getsingemp
  //employees/ajax_getsingemp_companies_details
  this.companyData.list=[];
  this.webService.commonPostMethod('employees/ajax_getsingemp_companies_details', requestObj).
    subscribe(
      data => {
        if (data.status == true) {
          this.authSessionService.cacheCompanyTokensFromResponse(data);
          this.companyData.data = data.empdata?data.empdata:{companies:[]};
          if(this.companyData.data.companies)
          {
            for(let i of this.companyData.data.companies)
            {
              i.name=i.company_title+"("+i.company_code+")"
              i.id=i.company_id.toString()
            }
            this.companyData.company_id= this.companyData.company_id.toString();
          }
          this.companyData.list=this.companyData.data.companies?this.companyData.data.companies:[]
          if(this.social_login)
          {
            this.companyData.list=this.companyData.data.companies.filter((v)=>{return v.social_login=='1'})
          }

        }
      }, error => {
      }
    );
  }
}
setCompany($event)
{

  try{
  this.previousCompanyIdBeforeSwitch = this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId().toString() : '';
  let x:any= {}
  let selectedCountry: any[] = [];
  // let countriesList = JSON.parse(localStorage.getItem('countriesList'))
  // selectedCountry = countriesList && countriesList.filter((country) => {
  //   return country.id === $event.value
  //  })
x = this.companyData.list.filter((v)=>{return v.id==this.companyData.company_id})[0];

  localStorage.setItem('country_data',null);
  localStorage.removeItem('menus');
  localStorage.removeItem('is_menu')
  this.costCenterStorageService.clearCostCenters().then(() => {
    this.webService.clearApiCache();
    this.setLocalStorage(x);
    this.getCountry();
  });
  }
  catch(err)
  {
    console.warn(err)
  }
}
revertCompanySelection() {
  let prevId = this.previousCompanyIdBeforeSwitch ? this.previousCompanyIdBeforeSwitch.toString() : '';
  if (prevId == '') {
    return;
  }

  let prevCompany = this.companyData.list.filter((v) => { return v.id == prevId })[0];
  this.companyData.company_id = prevId;

  if (!prevCompany) {
    return;
  }

  this.persistCompanySelection(prevCompany);
}

persistCompanySelection(data) {
  sessionStorage.setItem('company_id', data.company_id);
  if (this.eesdesService.get('ven_role', localStorage.getItem('ven_role')) == 'vendor') {
    localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
    localStorage.setItem("company_code", this.eesdesService.set(data.company_code));
    localStorage.setItem("company_title", this.eesdesService.set(data.company_title));
    localStorage.setItem("company_logo", this.eesdesService.set(data.company_logo));
    localStorage.setItem("company_theme", this.eesdesService.set(data.company_theme));
    localStorage.setItem("company_theme_text", this.eesdesService.set(data.company_theme_text));
    if (data.company_setup) {
      data.company_setup.MINUTES_UNITL_AUTO_LOGOUT = data.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10
      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', data.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
      data.company_setup.enable_strict_auto_logout_policy = data.company_setup.enable_strict_auto_logout_policy ? data.company_setup.enable_strict_auto_logout_policy : '0';
      localStorage.setItem('enable_strict_auto_logout_policy', data.company_setup.enable_strict_auto_logout_policy);
    }
  } else {
    localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set(data.employee_role));
    localStorage.setItem("company_title", this.eesdesService.set(data.company_title));
    localStorage.setItem("company_code", this.eesdesService.set(data.company_code));
    localStorage.setItem("company_logo", this.eesdesService.set(data.company_logo));
    if (data.company_setup) {
      data.company_setup.MINUTES_UNITL_AUTO_LOGOUT = data.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10
      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', data.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
      data.company_setup.enable_strict_auto_logout_policy = data.company_setup.enable_strict_auto_logout_policy ? data.company_setup.enable_strict_auto_logout_policy : '0';
      localStorage.setItem('enable_strict_auto_logout_policy', data.company_setup.enable_strict_auto_logout_policy);
    }
    localStorage.setItem("company_theme", this.eesdesService.set(data.company_theme));
    localStorage.setItem("company_theme_text", this.eesdesService.set(data.company_theme_text));
  }
}

setLocalStorage(data) {
  sessionStorage.setItem('company_id', data.company_id);
  if (this.eesdesService.get('ven_role',localStorage.getItem('ven_role')) == 'vendor') {
    this.setVendorDetails(data);
    localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
    localStorage.setItem("company_code", this.eesdesService.set(data.company_code));

    localStorage.setItem("company_title", this.eesdesService.set(data.company_title));
    localStorage.setItem("company_logo", this.eesdesService.set(data.company_logo));
    localStorage.setItem("company_theme", this.eesdesService.set(data.company_theme));
    localStorage.setItem("company_theme_text", this.eesdesService.set(data.company_theme_text));

    // localStorage.setItem("company_setup",JSON.stringify(data.company_setup));
    if (data.company_setup) {
    data.company_setup.MINUTES_UNITL_AUTO_LOGOUT= data.company_setup.MINUTES_UNITL_AUTO_LOGOUT? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',data.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                      data.company_setup.enable_strict_auto_logout_policy = data.company_setup.enable_strict_auto_logout_policy ? data.company_setup.enable_strict_auto_logout_policy : '0';
                      localStorage.setItem('enable_strict_auto_logout_policy',data.company_setup.enable_strict_auto_logout_policy);
    }
  }
  else {
    this.setEmployeeDetails(data);
    localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set(data.employee_role));
    localStorage.setItem("company_title", this.eesdesService.set(data.company_title));
    localStorage.setItem("company_code", this.eesdesService.set(data.company_code));

    localStorage.setItem("company_logo", this.eesdesService.set(data.company_logo));
    if (data.company_setup) {
    data.company_setup.MINUTES_UNITL_AUTO_LOGOUT= data.company_setup.MINUTES_UNITL_AUTO_LOGOUT? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',data.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                      data.company_setup.enable_strict_auto_logout_policy = data.company_setup.enable_strict_auto_logout_policy ? data.company_setup.enable_strict_auto_logout_policy : '0';
                      localStorage.setItem('enable_strict_auto_logout_policy',data.company_setup.enable_strict_auto_logout_policy);
    }
    // localStorage.setItem("company_setup",JSON.stringify(data.company_setup));
    // localStorage.setItem("department_id",data.department?data.department:'');
    // localStorage.setItem("department_name",data.department_name?data.department_name:'');
    // localStorage.setItem("profile_image", data.profile_image?data.profile_image:'');
    localStorage.setItem("company_theme", this.eesdesService.set(data.company_theme));
    localStorage.setItem("company_theme_text", this.eesdesService.set(data.company_theme_text));
  }
  this.getAccessToken(data);
  this.getUserDetailsForDepartment();
}

setVendorDetails(data) {

  localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
  sessionStorage.setItem('company_id', data.company_id);
  localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
  localStorage.setItem("emp_role", this.eesdesService.set("vendor"));


   if (this.companyData.list) {

     if (this.companyData.list) {


       for (let j of this.companyData.list) {

        if (j.company_id == data.company_id) {

          localStorage.setItem("employee_code", this.eesdesService.set(j.vendor_code));
          localStorage.setItem("company_title", this.eesdesService.set(j.company_title));
          localStorage.setItem("company_code", this.eesdesService.set(j.company_code));

          localStorage.setItem("company_logo", this.eesdesService.set(j.company_logo));
          localStorage.setItem("emp_role", this.eesdesService.set("vendor"));


          let user = {
            "email": j.email,
            "emp_details_id": j.vendor_id,

             "employeecode": j.vendor_code?j.vendor_code:'',
            "first_name": j.first_name,
            "gender": j.gender,
            "hiredate": j.hiredate,
            "id": j.id,
            "image": j.image,
            "last_name": j.last_name,
            "leavedate": j.leavedate,
            "middle_name": j.middle_name,
            "mobile": j.mobile,
            "password": j.password,
            "pincode": j.pincode,
            "status": j.status,
          }

        }
      }
    }
  }
  window.location.reload();

}

setEmployeeDetails(data) {
  if (this.companyData.data) {

    if (this.companyData.data.companies) {


      for (let j of this.companyData.data.companies) {

        if (j.company_id == data.company_id) {


          this.companyData.data.employee_role = j.employee_role;

          this.companyData.data.employee_code = j.employee_code;
          this.companyData.data.company_id = j.company_id;
          this.companyData.data.company_title = j.company_title;
          this.companyData.data.company_code = j.company_code?j.company_code:'';

          this.companyData.data.company_logo = j.company_logo;
          localStorage.setItem("employee_code", this.eesdesService.set(j.employee_code));
          j.company_setup=j.company_setup?j.company_setup:{};
          // localStorage.setItem("company_setup",JSON.stringify(j.company_setup));
          j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                      j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
                      localStorage.setItem('enable_strict_auto_logout_policy',j.company_setup.enable_strict_auto_logout_policy);



          let user = {
            "email": this.companyData.data.email,
            "emp_details_id": this.companyData.data.emp_details_id,

            "employeecode": this.companyData.data.employeecode,
            "first_name": this.companyData.data.first_name,
            "gender": this.companyData.data.gender,
            "hiredate": this.companyData.data.hiredate,
            "id": this.companyData.data.id,
            "image": this.companyData.data.image,
            "last_name": this.companyData.data.last_name,
            "leavedate": this.companyData.data.leavedate,
            "middle_name": this.companyData.data.middle_name,
            "mobile": this.companyData.data.mobile,
            "password": this.companyData.data.password,
            "pincode": this.companyData.data.pincode,

            "status": this.companyData.data.status,
          }

        }
      }
    }
  }
  localStorage.setItem("ven_role", this.eesdesService.set(""));

}
getAccessToken(companyObj?: any) {
  let companyId = this.eesdesService.get('company_id',localStorage.getItem('company_id')) ? this.eesdesService.get('company_id',localStorage.getItem('company_id')) : '0';
  let company = companyObj;
  if (!company && this.companyData && this.companyData.list) {
    company = this.authSessionService.findCompanyById(this.companyData.list, companyId);
  }
  let companyToken = this.authSessionService.getCompanyApiToken(companyId, company);
  let data = this.authSessionService.buildCompanyTokenLicensePayload(company, companyToken);
  if (data.status) {
    this.authSessionService.persistCompanyAccessToken(data.response);
    this.companyLicenseLoginService.handleTokenResponse(data, () => {
      this.New_getUserAccessToken();
    }, {
      onLicenseBlock: () => {
        this.revertCompanySelection();
      },
      onGenericError: (message) => {
        this.toasterService.pop("error", "Error", message);
        window.localStorage.clear();
        window.sessionStorage.clear()
        window.location.reload();
      }
    });
    return;
  }

  this.companyLicenseLoginService.handleTokenResponse(data, () => { }, {
    onLicenseBlock: () => {
      this.revertCompanySelection();
    },
    onGenericError: (message) => {
      this.toasterService.pop("error", "Error", message);
      window.localStorage.clear();
      window.sessionStorage.clear()
      window.location.reload();
    }
  });
}
getUserDetailsForDepartment() {
  console.log('company funtion called !')
  let requestObj = {
    "company_id": this.eesdesService.get('company_id',localStorage.getItem('company_id')) ? this.eesdesService.get('company_id',localStorage.getItem('company_id')) : '0',
    "emp_id": this.id ? this.id : '',
  }

  this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj).
    subscribe(
      data => {
        if (data.status == true) {
          let empDetails:any;
          empDetails = data;
          console.log(empDetails)
          if (empDetails.empdata != undefined && empDetails.empdata != '') {

              if (empDetails.empdata) {
                if (empDetails.empdata.companies) {
                  for (let j of empDetails.empdata.companies) {
                    if (j.employee_id == this.id) {
                      j.company_setup = j.company_setup ? j.company_setup : {};
                      // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                      j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                      j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
                      localStorage.setItem('enable_strict_auto_logout_policy',j.company_setup.enable_strict_auto_logout_policy);
                      localStorage.setItem("department_id", this.eesdesService.set(j.department?j.department:''));
                      localStorage.setItem("department_name", this.eesdesService.set(j.department_name?j.department_name:''));
                      localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image?j.profile_image:''));


                    }
                  }
                }
              }



          }
          else {
          }

        }


      }, error => {

      }
    );
}
already_active:boolean=false;
  New_getUserAccessToken() {
    let requestObj = {
      "company_id": this.eesdesService.get('company_id',localStorage.getItem('company_id')) ? this.eesdesService.get('company_id',localStorage.getItem('company_id')) : '0',
    }
    this.webService.commonPostMethod('User_session_management/generate_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            localStorage.setItem('user_access_token', this.eesdesService.set(data.response));
            this.authSessionService.persistUserSessionToken(data.response);
            this.authSessionService.clearTemporaryUserToken();
            this.showLogoutIssue(false);
            this.userLogin();
            // this.webService.redirectURL('/dashboard');
            window.location.reload();

          }
          else if(data.already_active)
          {
            this.already_active=true;
            this.already_active_msg=data.message;
            // this.showLogoutIssue(true);
            window.location.reload();
          }
          else {
            if (this.eesdesService.get('company_id',localStorage.getItem('company_id')) == null || this.eesdesService.get('company_id',localStorage.getItem('company_id')) == "0") {

              // this.webService.redirectURL('/dashboard');
              window.location.reload();

            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.sessionStorage.clear()
              window.location.href = window.location.href
            }
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  New_destroyUserToken() {
    let requestObj = {
      "company_id": this.eesdesService.get('company_id',localStorage.getItem('company_id')) ? this.eesdesService.get('company_id',localStorage.getItem('company_id')) : '0',
    }
    this.webService.commonPostMethod('User_session_management/destroy_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.New_getUserAccessToken();
            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.sessionStorage.clear()
              window.location.href = "";
            }

        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  userLogin(flag?:boolean) {
    const flags = flag ? flag : false;
    let url: any = "";
    if(!flags){
      url = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    }
    let payload = {
      // company_id" :15,
      //   "url":"login",
      //   "project" : "login",
      //   "module_name" : "login",
      //   "user_id" : 4972 ,
      //   "activity_type" :"login
      // "url": url,
       "project": this.getModule(url).project ? this.getModule(url).project : 'operation',
      // "module_name": this.getModule(url).menuName ? this.getModule(url).menuName : '',
      // "module_id": this.getModule(url).id ? this.getModule(url).id : '',
      "activity_type": 'login',
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      'user_id': this._localStorageService.getUserId(),
      'user_role_id': this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) : '0'
      // Do NOT send pop_show_date here — empty value can clear Support Popup frequency tracking.
      // Only Support OK acknowledge should write pop_show_date.
    }
    this.webService.commonPostMethod("User_activity/save_user_activity", payload).
      subscribe(
        data => {
          if (data.status) {
            this.already_active_msg=data.message;

          }

        },
        error => {
        }
      );

  }
  formatDateOnly(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  /**
   * Prefer emp pop_show_date; if API returns empty, keep last OK date from localStorage
   * so frequency days (1-30) still work until backend persists the field.
   */
  private resolveSupportPopupShowDate(empPopShowDate: any): string {
    const fromEmp = empPopShowDate != null ? String(empPopShowDate).trim() : '';
    if (fromEmp && fromEmp !== 'default') {
      try {
        localStorage.setItem('pop_show_date', fromEmp);
      } catch (e) {
      }
      return fromEmp;
    }
    let fromLocal = '';
    try {
      fromLocal = localStorage.getItem('pop_show_date') ? String(localStorage.getItem('pop_show_date')).trim() : '';
    } catch (e) {
      fromLocal = '';
    }
    if (fromLocal && fromLocal !== 'default') {
      return fromLocal;
    }
    return 'default';
  }
  
  // ---------- Utility: parse YYYY-MM-DD → Date ----------
  parseDateOnly(dateStr: string): Date {
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d); // local date, no time issues
  }
  
  // ---------- Add days to YYYY-MM-DD ----------
  addDays(dateStr: string, days: number): string {
    const date = this.parseDateOnly(dateStr);
    date.setDate(date.getDate() + days);
    return this.formatDateOnly(date);
  }

  getSupportPopupConfig(pop_show_date?: any, fallbackToggle?: boolean, fallbackDays?: number) {
    // Support popup is Dashboard-only — never evaluate/open on other pages.
    if (!this.isSupportPopupDashboardPage()) {
      this.popupService.open(false);
      return;
    }

    if (pop_show_date !== undefined) {
      this.supportPopupUserState = {
        popShowDate: pop_show_date,
        toggle: fallbackToggle,
        days: fallbackDays
      };
    }

    if (this.supportPopupConfigRequestStarted) {
      this.tryShowSupportPopup();
      return;
    }
    this.supportPopupConfigRequestStarted = true;

    const requestObj = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      "variable_list": ['support_popup_frequency', 'support_popup_frequency_days', 'support_popup_message'],
      "component": this.constructor.name ? this.constructor.name : '',
      "has_comp_access": '1'
    };

    const supportPopupConfigRequest = this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany_limited_as_requested", requestObj);
    if (!supportPopupConfigRequest) {
      this.supportPopupConfigReady = true;
      this.tryShowSupportPopup();
      return;
    }

    supportPopupConfigRequest.subscribe(
        data => {
          if (!this.isSupportPopupDashboardPage()) {
            this.popupService.open(false);
            return;
          }
          if (data.status) {
            const supportPopupConfig = data.response ? data.response : {};
            this.supportPopupConfigState = {
              hasToggleValue: supportPopupConfig.support_popup_frequency !== undefined
              && supportPopupConfig.support_popup_frequency !== null
              && supportPopupConfig.support_popup_frequency !== '',
              toggle: supportPopupConfig.support_popup_frequency == '1',
              days: supportPopupConfig.support_popup_frequency_days,
              message: supportPopupConfig.support_popup_message
            };
          }
          this.supportPopupConfigReady = true;
          this.tryShowSupportPopup();
        },
        error => {
          if (!this.isSupportPopupDashboardPage()) {
            this.popupService.open(false);
            return;
          }
          this.supportPopupConfigReady = true;
          this.tryShowSupportPopup();
        }
      );
  }

  private isSupportPopupDashboardPage(): boolean {
    const hashPath = this.getCurrentHashPath();
    if (hashPath === '/dashboard' || (hashPath && hashPath.endsWith('/dashboard'))) {
      return true;
    }
    return this.page_url === '/dashboard';
  }

  private tryShowSupportPopup() {
    if (this.supportPopupEvaluationCompleted || !this.supportPopupUserState || !this.supportPopupConfigReady) {
      return;
    }
    if (!this.isSupportPopupDashboardPage()) {
      this.popupService.open(false);
      return;
    }

    this.supportPopupEvaluationCompleted = true;
    const config = this.supportPopupConfigState;
    const toggle = config && config.hasToggleValue ? config.toggle : this.supportPopupUserState.toggle;
    // Prefer company meta days (1-30); keep numeric so "2" is applied correctly.
    const rawDays = config && config.days !== undefined && config.days !== null && config.days !== ''
      ? config.days
      : this.supportPopupUserState.days;
    const days = Number(rawDays) > 0 ? Number(rawDays) : 1;
    const message = config && config.message ? config.message : this.defaultSupportPopupMessage;
    this.showSupportPopup(this.supportPopupUserState.popShowDate, toggle, days, message);
  }

  showSupportPopup(pop_show_date: any, toggle: boolean, days: number, message?: string) {
    if (!this.isSupportPopupDashboardPage()) {
      this.popupService.open(false);
      return;
    }

    // last popup date (YYYY-MM-DD or empty)
    const last_pop_show_date = pop_show_date ? pop_show_date : '';
 
    const CS = Number(days) > 0 ? Number(days) : 1;
  
    // today in YYYY-MM-DD
     const todayStr = this.formatDateOnly(new Date());
    //const todayStr = '2026-01-01';
  
    // calculate next show date (YYYY-MM-DD)
    let next_show_date = '';
    if(last_pop_show_date != 'default' && last_pop_show_date != '' && last_pop_show_date != null && last_pop_show_date != undefined){
      next_show_date = this.addDays(last_pop_show_date, CS);
  
    }else if(last_pop_show_date == 'default'){
  
    }else{
      return;
    }
  

   // ---- LOGIC UNCHANGED ----
    if (
      toggle &&
      (
        last_pop_show_date === 'default' ||
        this.parseDateOnly(todayStr) >= this.parseDateOnly(next_show_date)
      )
    ) {
  
      this.popupService.setSupportPopupMessage(message ? message : this.defaultSupportPopupMessage);
      this.popupService.open(true);
    }
  }

   openAskQueryPopup() {
    const userDetails: any = this._localStorageService.getUserDetails() || {};
    const employeeDetails: any = this.empDetails && this.empDetails.empdata ? this.empDetails.empdata : {};
    this.loadAskQueryModules();
    let mobileNo = userDetails.mobile || userDetails.mobile_number || userDetails.phone_number || employeeDetails.mobile || '';
    mobileNo = (mobileNo + '').replace(/\D/g, '').substring(0, 10);
    this.askQueryData = {
      companyName: this.companyName || '',
      userName: this.userName || '',
      email: this._localStorageService.getUserEmail() || '',
      mobile: mobileNo,
      moduleId: '',
      moduleName: '',
      query: '',
      priority: ''
    };
    this.askQueryAttachments = [];
    this.pendingAskQueryPayload = null;
    this.isAskQueryModuleOpen = false;
    this.isAskQueryDragOver = false;
    this.isAskQueryPopupOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeAskQueryPopup() {
    this.isAskQueryModuleOpen = false;
    this.isAskQueryDragOver = false;
    this.isAskQueryPopupOpen = false;
    document.body.style.overflow = '';
  }

  askQueryNumberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  onAskQueryMobileInput(event: any) {
    const value = (event.target.value || '').replace(/\D/g, '').substring(0, 10);
    this.askQueryData.mobile = value;
    event.target.value = value;
  }

  onAskQueryFileSelected(event: any) {
    const files: FileList = event.target.files;
    if (!files || !files.length) {
      return;
    }
    for (let i = 0; i < files.length; i++) {
      this.uploadAskQueryFile(files[i]);
    }
    event.target.value = '';
  }

  onAskQueryDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isAskQueryDragOver = true;
  }

  onAskQueryDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isAskQueryDragOver = false;
  }

  onAskQueryDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isAskQueryDragOver = false;
    const files = event.dataTransfer && event.dataTransfer.files;
    if (!files || !files.length) {
      return;
    }
    for (let i = 0; i < files.length; i++) {
      this.uploadAskQueryFile(files[i]);
    }
  }

  uploadAskQueryFile(file: File) {
    const fileType = this.webService.getFileExtension(file.name);
    const fileName = this.webService.getFilename(file.name);
    if (!this.checkValidFileType(fileType)) {
      this.toasterService.pop('info', 'Info', 'File Type Should Be Valid');
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      const requestObj = {
        base64: reader.result,
        company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
        file_type: fileType,
        file_name: fileName,
        attachment: file.name
      };
      const uploadCall: any = this.webService.commonPostMethod('Query_form/save_query_form_file', requestObj);
      if (!uploadCall) {
        this.toasterService.pop('error', 'Error', 'Failed to upload file');
        return;
      }
      uploadCall.subscribe(
        (data: any) => {
          if (data.status) {
            this.askQueryAttachments.push({
              url: data.url ? data.url : '',
              name: data.response ? data.response : '',
              filename: fileName,
              filetype: fileType,
              iconclass: this.webService.getFileIcon(fileType)
            });
          } else {
            this.toasterService.pop('error', 'Error', data.message);
          }
        },
        (error: any) => {
          this.toasterService.pop('error', 'Error', 'Failed to upload file');
        }
      );
    };
    reader.readAsDataURL(file);
  }

  removeAskQueryAttachment(index: number) {
    this.askQueryAttachments.splice(index, 1);
  }

  submitAskQuery() {
    if (!this.askQueryData.mobile || !this.askQueryData.moduleId || !this.askQueryData.moduleName ||
      !this.askQueryData.query || !this.askQueryData.query.trim() || !this.askQueryData.priority) {
      this.toasterService.pop('info', 'Info', 'Please fill all required fields');
      return;
    }
    if (!this.webService.validmobile(this.askQueryData.mobile)) {
      this.toasterService.pop('info', 'Info', 'Please enter valid 10 digit mobile number');
      return;
    }

    let attachments: any = [];
    for (let x of this.askQueryAttachments) {
      attachments.push({
        attachment_url: x.url ? x.url : '',
        attachment_name: x.filename ? x.filename : '',
        attachment: x.name ? x.name : '',
        attchement_type: x.filetype ? x.filetype : ''
      });
    }

    this.pendingAskQueryPayload = {
      company_id: this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '0',
      user_id: this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '0',
      company_name: this.askQueryData.companyName,
      user_name: this.askQueryData.userName,
      email: this.askQueryData.email,
      mobile: this.askQueryData.mobile,
      module_id: this.askQueryData.moduleId,
      module_name: this.askQueryData.moduleName,
      query: this.askQueryData.query.trim(),
      priority: this.askQueryData.priority,
      attachments: attachments
    };

    // Needed because commonPostMethod overwrites module_name from page URL
    const pageUrl = '/' + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    const oldSearch = (this.webService.arrayForSearch || []).slice();
    this.webService.arrayForSearch = [{ id: this.askQueryData.moduleId, menuName: this.askQueryData.moduleName, url: pageUrl }].concat(oldSearch);
    const saveCall: any = this.webService.commonPostMethod('Query_form/ajax_save_query_form', this.pendingAskQueryPayload);
    this.webService.arrayForSearch = oldSearch;

    if (!saveCall) {
      this.toasterService.pop('error', 'Error', 'Unable to submit query');
      return;
    }
    saveCall.subscribe(
      (data: any) => {
        if (data.status) {
          this.toasterService.pop('success', 'Success', data.message ? data.message : 'Query form submitted successfully');
          this.closeAskQueryPopup();
        } else {
          this.toasterService.pop('error', 'Error', data.message ? data.message : 'Failed to submit query');
        }
      },
      (error: any) => {
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  // Show Classic / Modern buttons only when company meta enable_modern_ui is "1".
  // enable_modern_ui_by_default = "1" opens Modern UI unless the user picked Classic.
  loadEnableModernUiSetting(): void {
    let req = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId()
    };
    this.webService.commonPostMethod('Update_company_meta/ajax_getall_bycompany', req).subscribe(
      data => {
        const response = data && data.response ? data.response : {};
        rememberModernUiByDefault(response);
        this.enableModernUiFromCompany = data.status && response.enable_modern_ui == '1';
        const path = this.getCurrentHashPath();
        this.syncUiModeToggleVisibility(path);
      },
      () => {
        this.enableModernUiFromCompany = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3185250503/src/src/app/common/dynamic-menu/dynamic-menu.component.ts